<script setup>
import { computed } from 'vue';
import { useAuthStore } from '../../stores/auth';

/**
 * Who added a row, at the front of its meta line (prototype `byLead`, the
 * last of its attribution passes): "Maya Lewis · video conference · 30 min".
 * The name is ink and the rest of the line stays muted, so the eye lands on
 * the person without the row growing a line or a column.
 *
 * "you" for your own, not your name: it is the one thing a person scans for —
 * can I change this without asking anybody — and a name makes them match it
 * against themselves every time. Nothing when nobody is on record (the hub's
 * older items), and never in the portal: a policyholder deals with the agency.
 */
const props = defineProps({
  createdBy: { type: [Number, String, null], default: null },
  name: { type: String, default: null },
  // The " · " before whatever follows on the line; off when nothing does.
  separator: { type: Boolean, default: true },
});

const auth = useAuthStore();

const label = computed(() => {
  const viewer = auth.userData?.subdomain_user_id;
  if (props.createdBy != null && viewer != null && Number(props.createdBy) === Number(viewer)) return 'you';
  return props.name || '';
});
</script>

<template>
  <!-- The separator is interpolated: as bare text Vue condenses away the
       space before it, and the row read "Maya Lewis· Webinar". -->
  <template v-if="label"><span class="added-by" data-testid="added-by">{{ label }}</span>{{ separator ? ' · ' : '' }}</template>
</template>

<style scoped>
/* A span, not a <b>: some rows make <b> a block. */
.added-by {
  color: var(--xl-color-primary-text);
  font-weight: 600;
}
</style>
